export default __webpack_public_path__ + "images/edeb6ec1e8c77c0af165b893a470e0e6.svg";